// actions.js
import { React } from "react";
import history from "../../Helper/History";
import GetApiCall from "../../Api/GetApi";
import PostApiCall from "../../Api/Api";
import Notiflix from "notiflix";
import { toast } from "react-toastify";
import moment from "moment";
import { delay } from "../../Helper/ToastDelay";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
// Login Request
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_VERIFY = "LOGIN_VERIFY";
export const AUTH_TOKEN = "AUTH_TOKEN";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const USER_LOGOUT = "USER_LOGOUT";

// Thunk action creator
export const fetchData = (payload, method, url) => {
  Notiflix.Loading.standard();

  return async (dispatch) => {
    dispatch({ type: LOGIN_REQUEST });
    Notiflix.Loading.standard();

    const apiCall =
      method === "POST" ? PostApiCall.postRequest : GetApiCall.getRequest;
    // Remove LocalStorage Value
    try {
      const res = await apiCall(payload, url);

      const jsonData = await res.json();
      if (res.status === 200) {
        localStorage.setItem("authToken", jsonData.token);
        localStorage.setItem("user", JSON.stringify(jsonData.data));
        dispatch({ type: LOGIN_SUCCESS, payload: jsonData.data });
        Notiflix.Loading.remove();
        return jsonData.data;
      } else {
        if (payload?.isauth === true && jsonData.data !== "Email not found" && jsonData.data === "Email not verified") {

          return;
        } else if (jsonData.data === "Email not verified") {
          dispatch({ type: LOGIN_VERIFY, payload: jsonData.data });
        }else{
          dispatch({ type: LOGIN_ERROR, payload: jsonData.data });
          
        }

        toast.error(jsonData.data, { autoClose: 2000 });
        Notiflix.Loading.remove();
        return;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch({ type: LOGIN_ERROR, payload: error });
      toast.error(error.message);
      Notiflix.Loading.remove();
      return;
    }
  };
};

// history.push("/verifyemail", {
//   name: payload.email,
// });

export const logout = () => (dispatch) => {
  localStorage.removeItem("user");
  localStorage.removeItem("authToken");
  dispatch({ type: USER_LOGOUT });
  window.location.reload();
};
